import React from 'react';
import PropTypes from 'prop-types';

import { Box, Flex, ButtonFilled, ButtonText } from 'Components/Base';

const ReviewFooter = ({
  primaryButtonLabel,
  onPrimaryButtonClick,
  secondaryButtonLabel,
  onSecondaryButtonClick,
  isPrimaryDisabled,
  ...props
}) => {
  return (
    <Flex {...props}>
      {secondaryButtonLabel && (
        <ButtonText
          width={{ _: 1, md: 'auto' }}
          borderRadius={'100px'}
          onClick={onSecondaryButtonClick}
        >
          {secondaryButtonLabel}
        </ButtonText>
      )}
      {secondaryButtonLabel && primaryButtonLabel && (
        <Box pl={{ _: 0, md: 4 }} pt={{ _: 4, md: 0 }} />
      )}
      {primaryButtonLabel && (
        <ButtonFilled
          width={{ _: 1, md: 'auto' }}
          borderRadius={'100px'}
          onClick={onPrimaryButtonClick}
          disabled={isPrimaryDisabled}
        >
          {primaryButtonLabel}
        </ButtonFilled>
      )}
    </Flex>
  );
};

ReviewFooter.propTypes = {
  primaryButtonLabel: PropTypes.string,
  onPrimaryButtonClick: PropTypes.func,
  isPrimaryDisabled: PropTypes.bool,
  secondaryButtonLabel: PropTypes.string,
  onSecondaryButtonClick: PropTypes.func,
};

ReviewFooter.defaultProps = {
  onPrimaryButtonClick: () => {},
  onSecondaryButtonClick: () => {},
};

export default ReviewFooter;
